import React, {useState} from 'react';
import {Image, Modal} from 'antd';
import {Document, Page, pdfjs} from 'react-pdf';
import {fileBaseUrl} from '../../utils';
import style from './index.module.css';

/* ===== 1. 本地 worker ===== */
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

type FileItem = {
    id: number;
    url: string;
    name: string;
};

const CertificationPublicFile = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState<string>('');

    const fileList: FileItem[] = [
        {
            id: 1,
            url: `${fileBaseUrl()}Product-Carbon-Footprint-Certification-Logo.jpg`,
            name: '产品碳足迹认证标志',
        },
        {
            id: 2,
            url: `${fileBaseUrl()}Product-Carbon-Footprint-Certificate-Template.pdf`,
            name: '产品碳足迹证书模板',
        },
        {
            id: 3,
            url: `${fileBaseUrl()}Certification-Rules-Commitment-Statement.pdf`,
            name: '认证规则承诺书',
        },
        {
            id: 4,
            url: `${fileBaseUrl()}Self-Declaration-of-Legal-Certification-Activities.pdf`,
            name: '依法从事认证活动的自我声明',
        },
    ];

    const [previewSrc, setPreviewSrc] = useState<string>('');   // 空串=关闭
    const [showPreview, setShowPreview] = useState(false);

    /* 点击文件名：图片直接预览，PDF 弹窗 */
    const handleClick = (item: FileItem) => {
        const isImage = /\.(jpg|jpeg|png|gif|svg|webp)$/i.test(item.url);
        if (isImage) {
            setPreviewSrc(item.url);
            setShowPreview(true);
        } else {
            setPdfUrl(item.url);
            setModalOpen(true);
        }
    };

    /* PDF 弹窗关闭 */
    const closeModal = () => {
        setModalOpen(false);
        setPdfUrl('');
    };

    /* PDF 加载成功回调 */
    const [numPages, setNumPages] = useState<number>();
    const onDocumentLoadSuccess = ({numPages: total}: { numPages: number }) =>
        setNumPages(total);

    return (
        <>
            <div className={style.fileContainer}>
                {fileList.map((d) => (
                    <div
                        className={style.fileItem}
                        key={d.id}
                        onClick={() => handleClick(d)}
                    >
                        {d.name}
                    </div>
                ))}
            </div>

            {/* ===== PDF 预览弹窗 ===== */}
            <Modal
                title="PDF 预览"
                open={modalOpen}
                onCancel={closeModal}
                footer={null}
                width={860}
                bodyStyle={{maxHeight: '70vh', overflowY: 'auto', overflowX: 'hidden'}}
                destroyOnHidden={true}
            >
                <Document
                    file={pdfUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<div style={{textAlign: 'center'}}>正在加载 PDF...</div>}
                    error={<div style={{textAlign: 'center', color: 'red'}}>加载 PDF 失败</div>}
                >
                    {Array.from({length: numPages || 0}, (_, i) => (
                        <div key={`page_${i + 1}`} style={{marginBottom: 12}}>
                            <Page
                                pageNumber={i + 1}
                                width={800}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                            />
                        </div>
                    ))}
                </Document>
            </Modal>

            <Image
                style={{display: 'none'}}   // 本身不显示，只负责弹出层
                src={previewSrc}
                preview={{
                    visible: showPreview,
                    onVisibleChange: v => setShowPreview(v),
                }}
            />
        </>
    );
};

export default CertificationPublicFile;